import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "privacy-policy" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "policy-container" }
const _hoisted_4 = { class: "last-updated" }
const _hoisted_5 = { class: "policy-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicLayout = _resolveComponent("PublicLayout")!

  return (_openBlock(), _createBlock(_component_PublicLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Privacy Policy", -1)),
            _createElementVNode("p", _hoisted_4, "Last updated: " + _toDisplayString(_ctx.currentDate), 1),
            _cache[2] || (_cache[2] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "1. Introduction"),
              _createElementVNode("p", null, " Welcome to Prec8 (\"we,\" \"our,\" or \"us\"). We are committed to protecting your privacy and ensuring you understand how we collect, use, and safeguard your information when you use our Slack application and related services. "),
              _createElementVNode("p", null, " This Privacy Policy explains how we handle information when you use Prec8 to recognize and appreciate your team members through our Slack integration. ")
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "2. Information We Collect"),
              _createElementVNode("h3", null, "2.1 Information You Provide"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Slack Profile Information:"),
                  _createTextVNode(" When you connect Prec8 to your Slack workspace, we collect your Slack user ID, display name, email address, and profile information.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Workspace Information:"),
                  _createTextVNode(" We collect your Slack workspace ID, workspace name, and workspace settings.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Appreciation Messages:"),
                  _createTextVNode(" When you send appreciation messages using our emoji system, we collect the message content, recipients, and associated emoji usage.")
                ])
              ]),
              _createElementVNode("h3", null, "2.2 Information We Collect Automatically"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Usage Data:"),
                  _createTextVNode(" We collect information about how you use Prec8, including which features you use and how often.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Technical Information:"),
                  _createTextVNode(" We collect technical information such as your IP address, browser type, and device information.")
                ])
              ])
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "3. How We Use Your Information"),
              _createElementVNode("p", null, "We use the information we collect to:"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, "Provide and maintain the Prec8 service"),
                _createElementVNode("li", null, "Process and track appreciation tokens and rewards"),
                _createElementVNode("li", null, "Generate leaderboards and statistics"),
                _createElementVNode("li", null, "Send you notifications about your account and activity"),
                _createElementVNode("li", null, "Improve our services and develop new features"),
                _createElementVNode("li", null, "Ensure the security and integrity of our platform"),
                _createElementVNode("li", null, "Comply with legal obligations")
              ])
            ], -1)),
            _cache[5] || (_cache[5] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "4. Information Sharing and Disclosure"),
              _createElementVNode("p", null, "We do not sell, trade, or otherwise transfer your personal information to third parties, except in the following circumstances:"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Within Your Workspace:"),
                  _createTextVNode(" Appreciation messages and token information are visible to members of your Slack workspace who have access to Prec8.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Service Providers:"),
                  _createTextVNode(" We may share information with trusted third-party service providers who help us operate our service (e.g., hosting providers, analytics services).")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Legal Requirements:"),
                  _createTextVNode(" We may disclose information if required by law or to protect our rights and safety.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Business Transfers:"),
                  _createTextVNode(" In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.")
                ])
              ])
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "5. Data Security"),
              _createElementVNode("p", null, "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, "Encryption of data in transit and at rest"),
                _createElementVNode("li", null, "Regular security assessments and updates"),
                _createElementVNode("li", null, "Access controls and authentication measures"),
                _createElementVNode("li", null, "Secure hosting infrastructure")
              ])
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "6. Data Retention"),
              _createElementVNode("p", null, "We retain your information for as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy. Specifically:"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Account Information:"),
                  _createTextVNode(" Retained while your account is active and for a reasonable period after deactivation.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Appreciation Data:"),
                  _createTextVNode(" Retained to maintain leaderboards and statistics.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Usage Data:"),
                  _createTextVNode(" Retained for analytics and service improvement purposes.")
                ])
              ])
            ], -1)),
            _cache[8] || (_cache[8] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "7. Your Rights and Choices"),
              _createElementVNode("p", null, "You have the following rights regarding your personal information:"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Access:"),
                  _createTextVNode(" You can request access to the personal information we hold about you.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Correction:"),
                  _createTextVNode(" You can request that we correct inaccurate or incomplete information.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Deletion:"),
                  _createTextVNode(" You can request deletion of your personal information, subject to certain exceptions.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Portability:"),
                  _createTextVNode(" You can request a copy of your data in a portable format.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Opt-out:"),
                  _createTextVNode(" You can opt out of certain communications and data processing activities.")
                ])
              ])
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "8. Third-Party Services"),
              _createElementVNode("p", null, "Our service integrates with Slack and may use other third-party services. These services have their own privacy policies, and we encourage you to review them:"),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Slack:"),
                  _createTextVNode(" Our service operates within Slack's platform and is subject to Slack's privacy policy.")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, "Firebase:"),
                  _createTextVNode(" We use Firebase for data storage and hosting services.")
                ])
              ])
            ], -1)),
            _cache[10] || (_cache[10] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "9. Children's Privacy"),
              _createElementVNode("p", null, "Prec8 is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.")
            ], -1)),
            _cache[11] || (_cache[11] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "10. International Data Transfers"),
              _createElementVNode("p", null, "Your information may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and implement appropriate safeguards to protect your information.")
            ], -1)),
            _cache[12] || (_cache[12] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "11. Changes to This Privacy Policy"),
              _createElementVNode("p", null, "We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the \"Last updated\" date. Your continued use of Prec8 after any changes constitutes acceptance of the updated policy.")
            ], -1)),
            _cache[13] || (_cache[13] = _createElementVNode("section", { class: "policy-section" }, [
              _createElementVNode("h2", null, "12. Contact Us"),
              _createElementVNode("p", null, "If you have any questions about this Privacy Policy or our privacy practices, please contact us:"),
              _createElementVNode("div", { class: "contact-info" }, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "Email:"),
                  _createTextVNode(" privacy@prec8.com")
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "Website:"),
                  _createTextVNode(),
                  _createElementVNode("a", {
                    href: "https://prec8.com",
                    class: "link"
                  }, "https://prec8.com")
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
                class: "home-button"
              }, " ← Back to Home ")
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}